// src/pages/ClientsPage.js
import React, { useEffect, useState } from "react";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase"; // Ajusta la ruta si tu archivo firebase.js está en otra carpeta
import ClientsTable from "../components/ClientsTable";
import Analytics from "../components/Analytics";

const ClientsPage = () => {
  const [users, setUsers] = useState([]);

  useEffect(() => {
    // Suscripción en tiempo real a la colección "users"
    const unsubscribe = onSnapshot(collection(db, "users"), (snapshot) => {
      const docsArray = [];
      snapshot.forEach((doc) => {
        docsArray.push({
          id: doc.id,
          ...doc.data(),
        });
      });
      setUsers(docsArray);
    });

    return () => unsubscribe();
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-6 py-8">
      <ClientsTable clientsData={users} />
    </div>
  );
};

export default ClientsPage;
